import React, { useEffect } from 'react'
import styled from 'styled-components'
import { BaseLayout, Flex } from '@pancakeswap/uikit'
import PageSection from 'components/PageSection'
import useActiveWeb3React from 'contexts/Web3Context'
import useTheme from 'hooks/useTheme'
import useParsedQueryString from 'hooks/useParsedQueryString'
import { REFERRAL_KEY } from 'config/constants'
import Container from 'components/Layout/Container'
import { swapSectionData, earnSectionData, cakeSectionData } from './components/SalesSection/data'
import MetricsSection from './components/MetricsSection'
import SalesSection from './components/SalesSection'
import WinSection from './components/WinSection'
import FarmsPoolsRow from './components/FarmsPoolsRow'
import Hero from './components/Hero'
import Footer from './components/Footer'
import CakeDataRow from './components/CakeDataRow'
import { WedgeTopLeft, InnerWedgeWrapper, OuterWedgeWrapper, WedgeTopRight } from './components/WedgeSvgs'
import UserBanner from './components/UserBanner'
import TwitterCard from './components/TwitterCard'
import TotalValueLockedCard from './components/TotalValueLockedCard'

const StyledFooter = styled(BaseLayout)`
  align-items: stretch;
  justify-content: stretch;
  margin-bottom: 8px;

  & > div {
    grid-column: span 6;
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    & > div {
      grid-column: span 8;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & > div {
      grid-column: span 6;
    }
  }
`

const StyledPageSection = styled(PageSection)`
  padding-top: 18px;
  padding-bottom: 12px;
`

const Home: React.FC = () => {
  const { theme } = useTheme()
  const { account } = useActiveWeb3React()
  const parsedQs = useParsedQueryString()
  useEffect(() => {
    if (parsedQs && parsedQs.ref) {
      localStorage.setItem(REFERRAL_KEY, parsedQs.ref.toString())
    }
  }, [parsedQs])

  const HomeSectionContainerStyles = { margin: '0', width: '100%', maxWidth: '1024px', borderRadius: '24px', padding: '30px 40px' }

  return (
    <>
      <StyledPageSection
        innerProps={{ style: {...HomeSectionContainerStyles, background: '#3AC125B5'} }}
        background="transparent"
        index={2}
        hasCurvedDivider={false}
      >
        {/* <UserBannerWrapper>
          <UserBanner />
        </UserBannerWrapper> */}
        <Hero />
      </StyledPageSection>

      {/* <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        background={
          theme.isDark
            ? 'linear-gradient(180deg, #09070C 22%, #201335 100%)'
            : 'linear-gradient(180deg, #FFFFFF 22%, #D7CAEC 100%)'
        }
        index={2}
        hasCurvedDivider={false}
      >
        <MetricsSection />
      </PageSection> */}
      {/* <PageSection
        innerProps={{ style: HomeSectionContainerStyles }}
        background={theme.colors.background}
        index={2}
        hasCurvedDivider={false}
      >
        <OuterWedgeWrapper>
          <InnerWedgeWrapper top fill={theme.isDark ? '#201335' : '#D8CBED'}>
            <WedgeTopLeft />
          </InnerWedgeWrapper>
        </OuterWedgeWrapper>
        <SalesSection {...swapSectionData} />
      </PageSection> */}

      <StyledPageSection
        innerProps={{ style:  {...HomeSectionContainerStyles, background: '#508BE0B5'} }}
        background="transparent"
        index={2}
        hasCurvedDivider={false}
      >
        <CakeDataRow />
      </StyledPageSection>
      <StyledPageSection
        innerProps={{ style:  {...HomeSectionContainerStyles, background: '#9A671AB5'} }}
        background="transparent"
        index={2}
        hasCurvedDivider={false}
      >
        <FarmsPoolsRow />
      </StyledPageSection>
      <StyledPageSection
        innerProps={{ style:  {...HomeSectionContainerStyles, background: '#71975391', border: '1px solid #719753' } }}
        background="transparent"
        index={2} 
        hasCurvedDivider={false}
      >
        {/* <Footer /> */}
        <StyledFooter>
          <TwitterCard />
          <TotalValueLockedCard />
        </StyledFooter>
      </StyledPageSection>
    </>
  )
}

export default Home
